<template>
  <div v-if="!hasAdvertisementLink(currentAd)" class="w-full flex mt-5">
    <img
      class="rounded-lg w-full h-52 object-cover"
      :src="currentAd?.image"
      alt="detail-banner"
    />
  </div>

  <template v-else-if="isWebsiteLink">
    <a
      :href="externalLink"
      target="_blank"
      rel="noopener noreferrer"
      class="w-full flex mt-5"
      @click.stop
    >
      <img
        class="rounded-lg w-full h-52 object-cover"
        :src="currentAd?.image"
        alt="detail-banner"
      />
    </a>
  </template>

  <template v-else>
    <router-link
      :to="{
        name: getRouteParams(currentAd).name,
        params: getRouteParams(currentAd).params,
        query: getRouteParams(currentAd).query,
      }"
      class="w-full flex mt-5"
    >
      <img
        class="rounded-lg w-full h-52 object-cover"
        :src="currentAd?.image"
        alt="detail-banner"
      />
    </router-link>
  </template>
</template>

<script>
import { getRouteParams, hasAdvertisementLink } from '@/helpers';

export default {
  name: 'PosterBanner',

  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      adInterval: null,
      adImageIndex: 0,
      time: 0,
      currentAd: {
        link: '/',
        link_type: 0,
        image: '/img/logo.webp',
      },
    };
  },

  computed: {
    isWebsiteLink() {
      return hasAdvertisementLink(this.currentAd) && Number(this.currentAd?.link_type) === 0;
    },

    externalLink() {
      const link = String(this.currentAd?.link || '').trim();

      if (!link) {
        return '#';
      }

      if (
        link.startsWith('http://') ||
        link.startsWith('https://') ||
        link.startsWith('mailto:') ||
        link.startsWith('tel:')
      ) {
        return link;
      }

      return `https://${link}`;
    },
  },

  methods: {
    getRouteParams,
    hasAdvertisementLink,

    runInterval() {
      this.time = (this.currentAd?.duration || 5) * 1000;
      this.adInterval = setInterval(this.changeImage, this.time);
    },

    changeImage() {
      if (!this.content.length) return;

      this.adImageIndex = (this.adImageIndex + 1) % this.content.length;
      this.currentAd = this.content[this.adImageIndex];

      clearInterval(this.adInterval);
      this.runInterval();
    },
  },

  mounted() {
    if (!this.content.length) return;

    this.currentAd = this.content[0];

    if (this.content.length > 1) {
      this.runInterval();
    }
  },

  unmounted() {
    clearInterval(this.adInterval);
  },
};
</script>
